
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/startup-events/create",
      function () {
        return require("private-next-pages/startup-events/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/startup-events/create"])
      });
    }
  